import { IOrderFlexibleColumns } from '../../../../components/reusable/Table/types';
import { TFunction } from 'i18next';

export enum TABLE_COLUMNS_IDS {
  FIRSTNAME = 'firstname',
  lastname = 'lastname',
  EMAIL = 'email',
  ROLE = 'role.name',
  ACTIVE = 'active',
  UID = 'uid',
  HIDDEN = 'hidden',
  ACTIONS = 'ACTIONS',
}

const defaultOrderBy = TABLE_COLUMNS_IDS.FIRSTNAME;

function _getTableColumns(t: TFunction): IOrderFlexibleColumns[] {
  return [
    {
      id: TABLE_COLUMNS_IDS.FIRSTNAME,
      label: t('common.scope'),
      key: TABLE_COLUMNS_IDS.FIRSTNAME,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.FIRSTNAME,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.lastname,
      label: t('common.period'),
      key: TABLE_COLUMNS_IDS.lastname,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.lastname,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.EMAIL,
      label: t('common.email'),
      key: TABLE_COLUMNS_IDS.EMAIL,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.EMAIL,
      align: 'left',
      hided: false,
      canHide: false,
    },

    {
      id: TABLE_COLUMNS_IDS.ROLE,
      label: t('common.role'),
      key: TABLE_COLUMNS_IDS.ROLE,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.ROLE,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.ACTIVE,
      label: t('common.active'),
      key: TABLE_COLUMNS_IDS.ACTIVE,
      type: 'boolean',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.ACTIVE,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.UID,
      label: t('common.uid'),
      key: TABLE_COLUMNS_IDS.UID,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.UID,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.HIDDEN,
      label: t('common.hidden'),
      key: TABLE_COLUMNS_IDS.HIDDEN,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.HIDDEN,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.ACTIONS,
      key: TABLE_COLUMNS_IDS.ACTIONS,
      type: 'string',
      sortable: false,
      sortingKey: TABLE_COLUMNS_IDS.ACTIONS,
      align: 'left',
      hided: false,
      isFixed: true,
      canHide: false,
    },
  ];
}

const getTableColumns = (t: TFunction) => _getTableColumns(t);

const hidedColumns: string[] = [];

export const getDefaultSettings = (t: TFunction) => ({
  columnsOrderIds: Object.keys(_getTableColumns(t)).filter(
    (columnId) => !hidedColumns.includes(columnId),
  ),
  orderBy: defaultOrderBy,
  order: 'asc',
  hidedColumns,
});

export default getTableColumns;
